<template>
  <v-menu
    offsetY
    :offsetX="false"
    :right="isDirection('right')"
    :left="isDirection('left')"
    :content-class="menuContentClass"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        @click.native.stop.prevent
        class="dropdown-menu__button"
        :fab="fabButton"
        :small="size === 'small'"
        :x-small="size === 'x-small'"
        :icon="iconButton"
        v-on="on"
        :color="iconColor"
        :class="buttonsClass"
        :disabled="disabled"
        :loading="loading"
      >
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>

    <slot />
  </v-menu>
</template>

<script>
export default {
  name: 'DropdownMenuButton',
  props: {
    iconColor: {
      type: String,
      default: 'appMain',
    },
    contentClass: {
      type: String,
      default: 'dropdown-menu',
    },
    buttonsClass: {
      type: String,
    },
    iconButton: {
      type: Boolean,
      default: true,
    },
    fabButton: {
      type: Boolean,
      default: true,
    },
    dark: {
      type: Boolean,
      default: true,
    },
    disabled: Boolean,
    loading: Boolean,
    direction: {
      type: String,
      default: 'left',
    },
    size: {
      type: String,
      default: 'small',
    },
  },
  computed: {
    menuContentClass() {
      if (!this.contentClass) {
        return '';
      }
      const backgroundColor = `${this.contentClass}--${
        this.dark ? 'dark' : 'light'
      }`;
      return [this.contentClass, backgroundColor].join(' ');
    },
  },
  methods: {
    isDirection(direction) {
      return direction === this.direction;
    },
  },
};
</script>

<style lang="less">
.dropdown-menu {
  min-width: 200px !important;
  max-height: 100%;
  margin-top: 4px;

  &--dark {
    .v-list {
      background-color: var(--v-appMain-base);
      .v-list-item__title {
        color: #fff;
      }
    }
  }

  .v-list-item--disabled {
    opacity: 0.5;
  }
}
</style>
